import { render, staticRenderFns } from "./ProStudentManagement.vue?vue&type=template&id=5e6e4850&scoped=true&"
import script from "./ProStudentManagement.vue?vue&type=script&lang=js&"
export * from "./ProStudentManagement.vue?vue&type=script&lang=js&"
import style0 from "./ProStudentManagement.vue?vue&type=style&index=0&id=5e6e4850&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e6e4850",
  null
  
)

export default component.exports